import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/auth'; 
import { usePermissions } from '../../context/permissions';


const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth(); // Get user from context
  const { isSuperAdmin, isAdsAdmin, isGa4Admin } = usePermissions();

  // Determine user's name for greeting
  const userName = user ? (user.displayName || user.firstName || user.email) : 'Guest';

  return (
    <div className="space-y-6">
      {/* Welcome Message*/}
      <div className="mb-10"> {/* Increased bottom margin */}
        <h1 className="text-3xl font-semibold text-gray-800">
          Hello <span className="text-indigo-400">{userName}</span>,
        </h1>
        <p className="text-lg text-gray-600 mt-1">
          What would you like to do today?
        </p>
      </div>
      
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* User Management Card - Only visible to super admins, Google Ads admins, or GA4 admins */}
        {(isSuperAdmin || isAdsAdmin || isGa4Admin) && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col justify-between">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <span className="h-8 w-8 flex items-center justify-center text-indigo-400">
                  <span className="text-2xl font-mono border-b-2 border-indigo-400">&gt;</span>
                </span>
                <h3 className="text-lg font-semibold text-gray-800">Manage Access</h3>
              </div>
              <p className="text-gray-600 mt-2 mb-4">Manage user access across various platforms.</p>
            </div>
            <button 
              onClick={() => navigate('/dashboard/access-management')}
              className="mt-auto text-indigo-500 hover:text-indigo-600 flex items-center self-start"
            >
              Go to Access Management
            </button>
          </div>
        )}

        {/* Request Access Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col justify-between">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <span className="h-8 w-8 flex items-center justify-center text-indigo-400">
                <span className="text-2xl font-mono border-b-2 border-indigo-400">&gt;</span>
              </span>
              <h3 className="text-lg font-semibold text-gray-800">Request Access</h3>
            </div>
            <p className="text-gray-600 mt-2 mb-4">Request access to accounts in various platforms.</p>
          </div>
          <button 
            onClick={() => navigate('/dashboard/request-access')}
            className="mt-auto text-indigo-500 hover:text-indigo-600 flex items-center self-start"
          >
            Go to Request Access
          </button>
        </div>

        {/* Documentation Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col justify-between">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <span className="h-8 w-8 flex items-center justify-center text-indigo-400">
                <span className="text-2xl font-mono border-b-2 border-indigo-400">&gt;</span>
              </span>
              <h3 className="text-lg font-semibold text-gray-800">Documentation</h3>
            </div>
            <p className="text-gray-600 mt-2 mb-4">View documentation and guides for SafeMCC.</p>
          </div>
          <button 
            onClick={() => navigate('/dashboard/documentation')}
            className="mt-auto text-indigo-500 hover:text-indigo-600 flex items-center self-start"
          >
            Go to Documentation
          </button>
        </div>

        {/* MCC Accounts Card - Button Disabled */}
        {/* <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col justify-between">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <span className="h-8 w-8 flex items-center justify-center text-indigo-400">
                <span className="text-2xl font-mono border-b-2 border-indigo-400">&gt;</span>
              </span>
              <h3 className="text-lg font-semibold text-gray-800">MCC Accounts</h3>
            </div>
            <p className="text-gray-600 mt-2 mb-4">View MCC accounts access to various platforms.</p>
          </div>
          <button 
            onClick={() => {}} // Can be empty or removed as disabled prevents click
            disabled // Add disabled attribute
            className="mt-auto text-indigo-500 flex items-center self-start disabled:opacity-50 disabled:cursor-not-allowed hover:text-indigo-600" // Add disabled styles
          >
            Go to MCC Accounts
          </button>
        </div> */}

        {/* Admin Panel Card */}
        {isSuperAdmin && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col justify-between">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <span className="h-8 w-8 flex items-center justify-center text-indigo-400">
                  <span className="text-2xl font-mono border-b-2 border-indigo-400">&gt;</span>
                </span>
                <h3 className="text-lg font-semibold text-gray-800">Admin Panel</h3>
              </div>
              <p className="text-gray-600 mt-2 mb-4">Audit users and manage application settings (Super-Admins).</p>
            </div>
            <button 
              onClick={() => navigate('/dashboard/admin')}
              className="mt-auto text-indigo-500 hover:text-indigo-600 flex items-center self-start"
            >
              Go to the Admin Panel
            </button>
          </div>
        )}

        {/* View Profile Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col justify-between">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <span className="h-8 w-8 flex items-center justify-center text-indigo-400">
                <span className="text-2xl font-mono border-b-2 border-indigo-400">&gt;</span>
              </span>
              <h3 className="text-lg font-semibold text-gray-800">View Profile</h3>
            </div>
            <p className="text-gray-600 mt-2 mb-4">View your profile and access permissions.</p>
          </div>
          <button 
            onClick={() => navigate('/dashboard/profile')}
            className="mt-auto text-indigo-500 hover:text-indigo-600 flex items-center self-start"
          >
            Go to Your Profile
          </button>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
